export const CheckBoxListQcFieldName = 'checkBoxListQcFieldComponent';
